export const DB_NAME = 'InfiniteListDB';
export const STORE_NAME = 'items';
export const PAGE_SIZE = 20; // Number of items to fetch per page - increased for better performance
export const DEFAULT_SEED_COUNT = 500; // Default number of items to seed
export const MAX_ITEMS_IN_MEMORY = 100; // Max items to keep in memory for the list - increased for smoother scrolling
export const INITIAL_SEED_DAYS = 180; // Days of data to seed on initial startup
